import { Outlet, ScrollRestoration } from 'react-router-dom';
import { ApiHealthGate } from '@/components/ApiHealthGate';
import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import { VerifyBanner } from '@/features/auth/VerifyBanner';

export function Layout() {
  return (
    <div className="flex min-h-screen flex-col bg-bg">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-brand focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-white"
      >
        Skip to content
      </a>
      <ApiHealthGate />
      <Header />
      <VerifyBanner />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <ScrollRestoration />
    </div>
  );
}
